"use client";
import { SWRConfig } from "swr";

export default function SwrConfigProvider({ children, ...props }: React.ComponentProps<typeof SWRConfig>) {
  return <SWRConfig {...props}>{children}</SWRConfig>;
}
